module.exports = __webpack_public_path__ + "img/menu.76a47a0e.svg";